/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ch_Entry_DInputs */

const en_cp_ch_entry_d = /** @type {(inputs: Cp_Ch_Entry_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A workspace with ≥ 1 client-approved phase, a public benchmark entry, a ≤ 3-minute demo video, repo link for judges.`)
};

const id_cp_ch_entry_d = /** @type {(inputs: Cp_Ch_Entry_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace dengan ≥ 1 fase disetujui klien, entri benchmark publik, video demo ≤ 3 menit, tautan repo untuk juri.`)
};

/**
* | output |
* | --- |
* | "A workspace with ≥ 1 client-approved phase, a public benchmark entry, a ≤ 3-minute demo video, repo link for judges." |
*
* @param {Cp_Ch_Entry_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ch_entry_d = /** @type {((inputs?: Cp_Ch_Entry_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ch_Entry_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ch_entry_d(inputs)
	return en_cp_ch_entry_d(inputs)
});